import DataStoreService from "./dataStoreService";
import { IMemberProfileStoreService } from "../interfaces/IMemberProfileStoreService";
import member from '../../modules/member/member';
import { IMemberProfile } from "../../../models/interfaces/iMemberProfile";
import { IAddEditLocationsOutput } from '../../../models/interfaces/iAddEditLocationOutput';
import { IAboutMe } from "../../../models/interfaces/iAboutMe";
import { ISchool } from "../../../models/interfaces/ISchool";
import { ICompany } from "../../../models/interfaces/iCompany";
import { IQuote } from "../../../models/interfaces/iQuote";
import { IMemberFandomNonprofitsOutput } from "../../../models/interfaces/memberProfile/iMemberFandomNonprofitsOutput";
import { IPhilanthropy } from "../../../models/interfaces/IPhilanthropy";
import { IGetMemberNetworkOutput } from "../../../models/interfaces/memberProfile/iGetMemberNetworkOutput";
import { IAddEditCausesOutput } from "../../../models/interfaces/IAddCausesOutput";
import { ICompanyEditAddOutput } from "../../../models/interfaces/memberProfile/iCompanyEditAddOutput";
import { DiscoveryFilter } from "../../../models/classes/searchAndDiscovery/discoveryFilter";

export class MemberProfileStoreService extends DataStoreService implements IMemberProfileStoreService {
  constructor() {
    super('member');
  }

  get memberProfile(): IMemberProfile {
    return member.state.profile
  };

  getMemberProfileData(key: string): Promise<any> {
    return this.dispatch('getMemberProfileData', key);
  }
  getMemberShortlistedOpportunities(): Promise<any> {
    return this.dispatch('getMemberShortlistedOpportunities');
  }

  getMemberGeneralInformation(): Promise<any> {
    return this.dispatch('getMemberGeneralInformation');
  }

  getMemberLocations(): Promise<any> {
    return this.dispatch('getMemberLocations');
  }

  getMemberMetropolitanAreas(): Promise<any> {
    return this.dispatch('getMemberMetropolitanAreas');
  }
  getSubtypeOpportunitiesList(): Promise<any> {
    return this.dispatch('getSybtypeList');
  }

  getEventTypes(): Promise<any> {
    return this.dispatch('getEventTypes');
  }

  setMemberLocations(data: IAddEditLocationsOutput): Promise<any> {
    return this.dispatch('setMemberLocations', data);
  }

  editWorkExperience(companyEditAddOutput: ICompanyEditAddOutput): Promise<any> {
    return this.dispatch('editWorkExperience', companyEditAddOutput);
  }

  addWorkExperience(companyEditAddOutput: ICompanyEditAddOutput): Promise<any> {
    return this.dispatch('addWorkExperience', companyEditAddOutput);
  }

  editSchoolExperience(data: ISchool): Promise<any> {
    return this.dispatch('editSchoolExperience', data);
  }

  addSchoolExperience(data: ISchool): Promise<any> {
    return this.dispatch('addSchoolExperience', data);
  }
  setMemberCurrentLocation(key: string): Promise<any> {
    return this.dispatch('setMemberCurrentLocation', key);
  }

  updateAboutMe(data: IAboutMe): Promise<any> {
    return this.dispatch('updateAboutMe', data);
  }

  updateSchoolExperience(data: ISchool): Promise<any> {
    return this.dispatch('updateSchoolExperience', data);
  }

  updateWorkExperience(data: ICompany): Promise<any> {
    return this.dispatch('updateWorkExperience', data);
  }

  updateQuote(data: IQuote): Promise<any> {
    return this.dispatch('updateQuote', data);
  }

  getMemberFandomNonprofits(data: IMemberFandomNonprofitsOutput): Promise<any> {
    return this.dispatch('getMemberFandomNonprofits', data);
  }

  updatePhilanthropyExperience(data: IPhilanthropy): Promise<any> {
    return this.dispatch('updatePhilanthropyExperience', data);
  }

  addPhilanthropyExperience(data: IPhilanthropy): Promise<any> {
    return this.dispatch('addPhilanthropyExperience', data);
  }

  setMemberNetwork(data: IGetMemberNetworkOutput): Promise<any> {
    return this.dispatch('setMemberNetwork', data);
  }

  setCompanyNetwork(data: IGetMemberNetworkOutput): Promise<any> {
    return this.dispatch('setCompanyNetwork', data);
  }

  setSchoolNetwork(data: IGetMemberNetworkOutput): Promise<any> {
    return this.dispatch('setSchoolNetwork', data);
  }

  setNonprofitNetwork(data: IGetMemberNetworkOutput): Promise<any> {
    return this.dispatch('setNonprofitNetwork', data);
  }

  changeCauses(data: IAddEditCausesOutput): Promise<any> {
    return this.dispatch('changeCauses', data);
  }

  setFavorites(key: string): Promise<any> {
    return this.dispatch('setFavorites', key);
  }

  getMetropolitanAreas(): Promise<any> {
    return this.dispatch('getMetropolitanAreas');
  }

  getMemberDiscoveryFilter(key: DiscoveryFilter): Promise<any> {
    return this.dispatch('setDiscoveryFilter', key);
  }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/services/classes/memberProfileStoreService.ts